// check if element is present on the page
// (feels like we shouldn't need that but I kinda don't want to use settimeout/interval)
function rafAsync() {
  return new Promise((resolve) => {
    requestAnimationFrame(resolve); // faster than set time out
  });
}

async function checkElement(selector) {
  let querySelector = null;
  while (querySelector === null) {
    // eslint-disable-next-line no-await-in-loop
    await rafAsync();
    querySelector = document.querySelector(selector);
  }
  return querySelector;
}

export default checkElement;
